export const OPERATION_LIST = [
    ['createTime', '操作时间'],
    ['uid', '投放账户ID'],
    ['type', '类型'],
    ['status', '状态'],
    ['operate', '操作'],
]

export const OPERATION_STATUS = {
    WAIT_BIND_AUDIT: 1, // 绑定待审核
    BIND_AUDIT_PASS: 2, // 已绑定
    REJECT_BIND: 3, // 绑定驳回
    WAIT_CHANGE_UID_AUDIT: 4, // 换绑待审核
    CHANGE_UID_AUDIT_PASS: 5, // 已换绑
    REJECT_CHANGE_UID_AUDIT: 6, // 换绑驳回
    WAIT_CHANGE_OPENID_AUDIT: 7, // 更换QQ待审核
    REJECT_CHANGE_OPENID_AUDIT: 8, // 更换QQ驳回
    UNBIND_PASS: 9, // 已解绑
}

export const OPERATION_AD_TYPE = {
    KA: 1,
    DIRECT: 2,
}

export const ACCOUNT_TYPE = {
    SERVICE_PROVIDER: 1,
    DIRECT: 2,
}

export const OPERATION_DIALOG = {
    BIND: 1,
    REPLACE: 2,
}

export const OPERATION_AD_TYPE_NAME = {
    [OPERATION_AD_TYPE.KA]: '应用宝代理',
    [OPERATION_AD_TYPE.DIRECT]: '腾讯广告投放',
}

export const OPERATION_STATUS_NAME = {
    [OPERATION_STATUS.WAIT_BIND_AUDIT]: '绑定待审核',
    [OPERATION_STATUS.BIND_AUDIT_PASS]: '已绑定',
    [OPERATION_STATUS.REJECT_BIND]: '绑定驳回',
    [OPERATION_STATUS.WAIT_CHANGE_UID_AUDIT]: '换绑待审核',
    [OPERATION_STATUS.CHANGE_UID_AUDIT_PASS]: '已换绑',
    [OPERATION_STATUS.REJECT_CHANGE_UID_AUDIT]: '换绑驳回',
    [OPERATION_STATUS.WAIT_CHANGE_OPENID_AUDIT]: '更换QQ待审核',
    [OPERATION_STATUS.REJECT_CHANGE_OPENID_AUDIT]: '更换QQ驳回',
    [OPERATION_STATUS.UNBIND_PASS]: '已解绑',
}

export const ALLOWED_REPLACE_STATUS = [OPERATION_STATUS.BIND_AUDIT_PASS]
export const REJECTED_STATUS = [
    OPERATION_STATUS.REJECT_BIND,
    OPERATION_STATUS.REJECT_CHANGE_UID_AUDIT,
    OPERATION_STATUS.REJECT_CHANGE_OPENID_AUDIT,
]

export const CHANNEL_PKG_STATUS_LIST = [
    {
        label: '全部',
        value: -1,
    },
].concat(
    Object.values(OPERATION_STATUS).map(status => {
        return {
            label: OPERATION_STATUS_NAME[status],
            value: status,
        }
    })
)
